import React from 'react';
import PropTypes from 'prop-types';
import Overlay from 'react-bootstrap/Overlay';
import ReactTooltip from 'react-bootstrap/Tooltip';
import { getSanitizedHtml } from '../util/getSanitizedHtml';


const Tooltip = React.forwardRef(({ text, customComponent, showTooltip, index, placement="bottom", modifiers = [], tooltipStyle = {} }, ref) => {
    // Auto-resolve placement when the preferred side has no room
    let resolvedPlacement = placement;
    if (ref?.current) {
        const rect = ref.current.getBoundingClientRect();
        const pad = 120; // minimum space needed for the tooltip
        if (placement === 'left' && rect.left < pad) {
            resolvedPlacement = rect.right + pad < window.innerWidth ? 'right' : 'top';
        } else if (placement === 'right' && window.innerWidth - rect.right < pad) {
            resolvedPlacement = rect.left > pad ? 'left' : 'top';
        }
    }

    const appliedTooltipStyle = { ...tooltipStyle };
    if (tooltipStyle.maxWidth) {
        // Bootstrap controls width via --bs-tooltip-max-width on .tooltip-inner
        appliedTooltipStyle['--bs-tooltip-max-width'] = tooltipStyle.maxWidth;
    }

    return (
        <Overlay target={ref.current} show={showTooltip} key={index} placement={resolvedPlacement} popperConfig={{ modifiers }}>
            {(props) => (
                <ReactTooltip {...props} style={{ ...props.style, pointerEvents: "none", ...appliedTooltipStyle }}>
                    {customComponent || <span dangerouslySetInnerHTML={getSanitizedHtml(text, '')}></span>}
                </ReactTooltip>
            )}
        </Overlay>
    );
});

Tooltip.propTypes = {
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    customComponent: PropTypes.node,
    showTooltip: PropTypes.bool,
    index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    placement: PropTypes.string,
    modifiers: PropTypes.array,
    tooltipStyle: PropTypes.object,
    style: PropTypes.object,
};

export default Tooltip;
